export const filter = {
    id: "",
    name: "",
    start: "",
    end: "",
    created_at: "",
    updated_at: "",
};
